var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.stage === "released"
    ? _c("div", { staticClass: "text-center" }, [_vm._m(0)])
    : _vm.stage === "alerting" || _vm.stage === "grace-period"
    ? _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("p", [
            _c("span", { staticClass: "display-block" }, [
              _vm._v("Your year of Pro services for backing FA5 expires on:"),
            ]),
            _vm._v(" "),
            _c(
              "strong",
              { staticClass: "display-block size-lg margin-top-2xs" },
              [_vm._v(_vm._s(_vm.expiresDateFormatted) + "!")]
            ),
          ]),
          _vm._v(" "),
          _vm.allowPlanActions
            ? [
                _c(
                  "site-link",
                  {
                    staticClass: "link primary",
                    attrs: { to: { name: "plans" } },
                  },
                  [_vm._v("\n      Start a Subscription\n    ")]
                ),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm.stage === "shutoff"
    ? _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("p", [
            _c("span", { staticClass: "display-block" }, [
              _vm._v("Your year of Pro services for backing FA5 expired on:"),
            ]),
            _vm._v(" "),
            _c(
              "strong",
              { staticClass: "display-block size-lg margin-top-2xs" },
              [_vm._v(_vm._s(_vm.expiresDateFormatted) + "!")]
            ),
          ]),
          _vm._v(" "),
          _vm.allowPlanActions
            ? _c(
                "site-link",
                {
                  staticClass: "link primary",
                  attrs: { to: { name: "plans" } },
                },
                [_vm._v("\n    Start a Subscription\n  ")]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("span", { staticClass: "display-block" }, [
        _vm._v("Your early backing gets you a"),
      ]),
      _vm._v(" "),
      _c("strong", { staticClass: "display-block size-lg margin-top-2xs" }, [
        _vm._v("full year of Pro services."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }